import { DropdownChevron } from '#/components/Dropdown/Chevron/DropdownChevron';
import { Dropdown } from '#/components/Dropdown/Dropdown';
import { DropdownFoldMenu } from '#/components/Dropdown/menus/Fold/DropdownFoldMenu';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { LayoutHeaderButton } from '#/layouts/Layout/Header/Button/LayoutHeaderButton';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';

import { volunteerDropdownDataByLocale } from './data/volunteerDropdownDataByLocale';
import {
  volunteerDropdownDataByResourcesItemType,
  volunteerDropdownDataBySearchItemType,
} from './volunteerDropdownConstants';

const triggerTextByLocale: Record<I18nLocale, { text: string; href: string }> =
  {
    en: {
      text: 'Volunteer',
      href: searchGetVolopsPath({
        locale: I18nLocale.EN,
        embedSearchWidgetId: null,
      }),
    },
    es: {
      text: 'Voluntariado',
      href: searchGetVolopsPath({
        locale: I18nLocale.ES,
        embedSearchWidgetId: null,
      }),
    },
  };

type Props = {
  locale: I18nLocale;
};

export function VolunteerDropdown({ locale }: Props) {
  const { text, href } = triggerTextByLocale[locale];
  const { search, resources } = volunteerDropdownDataByLocale[locale];

  return (
    <Dropdown
      trigger={
        <LayoutHeaderButton
          variant="grey"
          qaId="page-header-volunteer-dropdown-trigger"
          data={{ type: 'inert' }}
          desktopData={{
            type: 'link',
            href,
            clickActions: {
              track: {
                name: 'Volunteer',
                properties: { context: 'Header' },
              },
            },
          }}
        >
          {text} <DropdownChevron />
        </LayoutHeaderButton>
      }
      desktopTriggersOnHover
    >
      <DropdownFoldMenu
        left={{
          title: search.title,
          width: 260,
          items: search.items.map((searchItem) => {
            const { iconName, qaId, trackClickedName } =
              volunteerDropdownDataBySearchItemType[searchItem.type];

            return {
              iconName,
              title: searchItem.title,
              href: searchItem.href,
              qaId,
              trackClicked: {
                name: trackClickedName,
                context: 'Header Dropdown > Volunteer',
              },
            };
          }),
        }}
        right={{
          title: resources.title,
          items: resources.items.map((resourceItem) => {
            const { image, imageHover, qaId, trackClickedName } =
              volunteerDropdownDataByResourcesItemType[resourceItem.type];

            return {
              image,
              imageHover,
              title: resourceItem.title,
              description: resourceItem.description,
              href: resourceItem.href,
              qaId,
              trackClicked: {
                name: trackClickedName,
                context: 'Header Dropdown > Volunteer',
              },
            };
          }),
        }}
      />
    </Dropdown>
  );
}
